import "../../../styles/input.scss";

import React, {Component} from "react";

import PropTypes from "prop-types";

export default class DropDownMenu extends Component {
    constructor(props){
        super(props);
        
        this.eatEvent = this.eatEvent.bind(this);

        this.setNodeBorder = this.setNodeBorder.bind(this);
        this.setNodeList = this.setNodeList.bind(this);
    }

    eatEvent(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    setNodeBorder(node) {
        this.nodeBorder = node;
    }
    setNodeList(node) {
        this.nodeList = node;
    }

    render() {
        const {
            children,
            style,
            className,
            isDroppedDown,
            maxHeight,
            useBorder,
        } = this.props;

        return(
            <React.Fragment>
                {isDroppedDown===true && useBorder && (<div className={`dropdown-menu-border-top${className ? ` ${className}` : ""}`} style={{...style}}/>)}
                <div className={`dropdown-menu-list${isDroppedDown?"":"-up"}${className ? ` ${className}` : ""}`} style={{...style,maxHeight:maxHeight==null?undefined:maxHeight-4}} onClick={this.eatEvent}>
                    {children}
                </div>
                {isDroppedDown===false && useBorder && (<div className={`dropdown-menu-border-bottom${className ? ` ${className}` : ""}`} style={{...style}}/>)}
            </React.Fragment>
        );
    }
}

DropDownMenu.propTypes = {
    maxHeight: PropTypes.number,
    isDroppedDown: PropTypes.bool,
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
    useBorder: PropTypes.bool,
};
DropDownMenu.defaultProps = {
    isDroppedDown: true,
    useBorder: true,
};